import { render, staticRenderFns } from "./TituloRelatorioIrmaos.vue?vue&type=template&id=1d12d620&"
import script from "./TituloRelatorioIrmaos.vue?vue&type=script&lang=js&"
export * from "./TituloRelatorioIrmaos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports